module.exports = "<div class=\"matching-fares-table\">\n  <ng2-smart-table [settings]=\"settings\" [source]=\"tableSource\"></ng2-smart-table>\n</div>\n"